import fm from 'format-message';
import PropTypes from 'prop-types';
import useBasketTypeUpdate from '@activebrands/core-web/hooks/useBasketTypeUpdate.ts';
import { useStyletron } from '@activebrands/core-web/libs/styletron';
import CheckoutHeading from 'templates/CheckoutPage/CheckoutHeading';
import ShippingMethods from 'templates/CheckoutPage/DeliverySection/ShippingMethods';

const DeliverySection = ({ $style = {}, basketType, currentCheckoutStep, setCurrentCheckoutStep, deliveryStep }) => {
    const [css] = useStyletron();

    useBasketTypeUpdate({ basketType, currentCheckoutStep, deliveryStep });

    return (
        <div className={css($style)}>
            <CheckoutHeading
                editButtonVisible={currentCheckoutStep > deliveryStep}
                label={fm('Shipping')}
                onClickEdit={() => setCurrentCheckoutStep(deliveryStep)}
            />
            <ShippingMethods
                $style={{ margin: '24px var(var(--margin-content)) 64px' }}
                currentCheckoutStep={currentCheckoutStep}
                deliveryStep={deliveryStep}
                setCurrentCheckoutStep={setCurrentCheckoutStep}
            />
        </div>
    );
};

DeliverySection.propTypes = {
    $style: PropTypes.object,
    basketType: PropTypes.string,
    currentCheckoutStep: PropTypes.number,
    deliveryStep: PropTypes.number,
    setCurrentCheckoutStep: PropTypes.func,
};

export default DeliverySection;
